import React from "react";
import { APP_VERSION, API_BASE_URL } from "../constants";

export default function AboutPage() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>Drumly Admin Panel</h1>
        </div>

        <div style={styles.infoGrid}>
          <div style={styles.infoItem}>
            <h3 style={styles.infoLabel}>Versiyon</h3>
            <p style={styles.infoValue}>v{APP_VERSION}</p>
          </div>

          <div style={styles.infoItem}>
            <h3 style={styles.infoLabel}>API Adresi</h3>
            <p style={styles.infoValue}>{API_BASE_URL}</p>
          </div>

          <div style={styles.infoItem}>
            <h3 style={styles.infoLabel}>Ortam</h3>
            <p style={styles.infoValue}>{process.env.NODE_ENV}</p>
          </div>
        </div>

        <div style={styles.description}>
          <p style={styles.descText}>
            Drumly Admin Panel, müzik ve beat yönetimi için geliştirilmiş modern
            bir yönetim paneli uygulamasıdır.
          </p>
        </div>

        <div style={styles.footer}>
          <p style={styles.copyright}>
            © {new Date().getFullYear()} Drumly. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </div>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
    padding: "2rem",
  },
  card: {
    background: "rgba(31, 41, 55, 0.95)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "1rem",
    padding: "2rem",
    maxWidth: "600px",
    width: "100%",
    boxShadow: "0 20px 50px rgba(0, 0, 0, 0.3)",
  },
  header: {
    textAlign: "center" as "center",
    marginBottom: "2rem",
  },
  icon: {
    fontSize: "3rem",
    display: "block",
    marginBottom: "1rem",
  },
  title: {
    color: "white",
    fontSize: "2rem",
    fontWeight: "700",
    margin: "0",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "1.5rem",
    marginBottom: "2rem",
  },
  infoItem: {
    background: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "0.5rem",
    padding: "1rem",
  },
  infoLabel: {
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "0.875rem",
    fontWeight: "500",
    margin: "0 0 0.5rem 0",
    textTransform: "uppercase" as "uppercase",
    letterSpacing: "0.05em",
  },
  infoValue: {
    color: "white",
    fontSize: "1rem",
    fontWeight: "600",
    margin: "0",
    fontFamily: "monospace",
    wordBreak: "break-all" as "break-all",
  },
  description: {
    background: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "0.5rem",
    padding: "1.5rem",
    marginBottom: "1.5rem",
  },
  descText: {
    color: "rgba(255, 255, 255, 0.8)",
    fontSize: "1rem",
    lineHeight: "1.6",
    margin: "0",
    textAlign: "center" as "center",
  },
  footer: {
    textAlign: "center" as "center",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
    paddingTop: "1rem",
  },
  copyright: {
    color: "rgba(255, 255, 255, 0.6)",
    fontSize: "0.875rem",
    margin: "0",
  },
};
